import { createSelector } from 'reselect';

export const getComponentState = state => state.adminForms;

export const getForms = createSelector(
    getComponentState,
    (state) => state.forms
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getSaving = createSelector(
    getComponentState,
    (state) => state.saving
);
export const getIsRejecting = createSelector(
    getComponentState,
    (state) => state.isRejecting
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getForm = createSelector(
    getComponentState,
    (state) => state.form
);
export const getPdfFile = createSelector(
    getComponentState,
    (state) => state.pdfFile
);
export const getPreviewFile = createSelector(
    getComponentState,
    (state) => state.previewFile
);
export const getDepartments = createSelector(
    getComponentState,
    (state) => state.departments
);
export const getIsDeleting = createSelector(
    getComponentState,
    (state) => state.isDeleting
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getIsUploading = createSelector(
    getComponentState,
    (state) => state.isUploading
);
export const getUploadFile = createSelector(
    getComponentState,
    (state) => state.uploadFile
);
export const getAllDepartments = createSelector(
    getComponentState,
    (state) => state.allDepartments
);